module.exports = __webpack_public_path__ + "img/logo.dfc291b3.svg";